import "./index.css";
import { Routes, Route, Navigate } from "react-router-dom";
import PrivateRoute from "./components/privateRoute";
import Login from "./pages/Login";
import Verification from "./pages/Verification";
import Dashboard from "./pages/Dashboard";
import WebScraping from "./pages/WebScraping";
import DashboardTebular from "./pages/DashboardTebular";

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/login" replace />} />
      <Route path="/login" element={<Login />} />
      <Route path="/verification" element={<Verification />} />

      <Route
        path="/user-details"
        element={<PrivateRoute allowedRoles={["admin"]} component={Dashboard} />}
      />

      <Route
        path="/webscraping"
        element={<PrivateRoute allowedRoles={["admin"]} component={WebScraping} />}
      />

      <Route
        path="/environment-data"
        element={
          <PrivateRoute
            allowedRoles={["admin", "user"]}
            component={DashboardTebular}
          />
        }
      />
    </Routes>
  );
}
